import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ text = "Carregando..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
      <p className="text-gray-500 mt-3">{text}</p>
    </div>
  );
}